import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import { toast } from 'react-hot-toast';
import { useServerSideTable } from '../../../hooks/useServerSideTable';
import { getPagedNotifications, deleteNotification } from '../../../services/notificationService';
import { Notification } from '../../../types/notification';
import { getNotificationColumns } from './NotificationColumns';
import Table from '../../../components/common/Table';
import ConfirmDialog from '../../../components/common/ConfirmDialog';
import pageStyles from '../../Page.module.css';
import Icon from '../../../components/common/Icon';
//import sharedStyles from '../../SharedPageStyles.module.css';

interface TableHeaderProps {
  searchTerm: string;
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}

// 2. استخدم هذه الواجهة في تعريف المكون
const TableHeader: React.FC<TableHeaderProps> = ({ searchTerm, setSearchTerm }) => {
  return (
    <div style={{ marginBottom: '1rem', maxWidth: '400px' }}>
      <input
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="ابحث في الجدول..."
        style={{ width: '100%', padding: '0.8rem', borderRadius: '6px', border: '1px solid #ccc' }}
      />
    </div>
  );
};
const NotificationsListPage: React.FC = () => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [notificationToDelete, setNotificationToDelete] = useState<Notification | null>(null);

  const openDeleteDialog = (notification: Notification) => {
    setNotificationToDelete(notification);
    setIsDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setNotificationToDelete(null);
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    if (!notificationToDelete) return;
    const promise = deleteNotification(notificationToDelete.id);
    toast.promise(promise, {
      loading: 'جاري حذف التنبيه...',
      success: () => {
        closeDeleteDialog();
        refreshData();
        return 'تم حذف التنبيه بنجاح!';
      },
      error: (err) => {
        closeDeleteDialog();
        return err.response?.data?.message || 'فشل في حذف التنبيه.';
      },
    });
  };

  const columns = useMemo(() => getNotificationColumns(openDeleteDialog), []);

  const { table, isLoading,Pagination, refreshData, searchTerm, setSearchTerm } = useServerSideTable<Notification>({
    columns,
    fetchData: getPagedNotifications,
  });

  return (
    <div className={pageStyles.pageContainer}>
      <div className={pageStyles.pageHeader}>
        <h1>إدارة التنبيهات</h1>
        <Link to="/admin/notifications/add" className={pageStyles.addButton}>
          <Icon as={FaPlus} style={pageStyles.icon } />
          <span>إرسال تنبيه جديد</span>
        </Link>
      </div>
      <div className={pageStyles.pageContent}>
        <TableHeader searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        <Table<Notification> table={table} isLoading={isLoading} />
        <Pagination />
      </div>
      <ConfirmDialog
        isOpen={isDeleteDialogOpen}
        title="تأكيد الحذف"
        message={`هل أنت متأكد من رغبتك في حذف التنبيه بعنوان "${notificationToDelete?.title}"؟`}
        onConfirm={handleDelete}
        onCancel={closeDeleteDialog}
      />
    </div>
  );
};

export default NotificationsListPage;
